<template>
<div v-if="showModal">
    <!-- modal custom -->
    <div>
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <!-- Header Modal -->
          <div class="modal-header">
              <h3>{{modalTitleMessage}}</h3>
          </div>
          <!-- Body Modal -->
          <div class="modal-body">
              <p> {{modalParagraphMessage}} </p>
          </div>
          <!-- Footer Modal -->
          <div class="modal-footer">
            <div class="footer-modal-button-group">
              <!-- Bouton Confirmer !-->
              <button class="modal-button-close" @click="$emit('btnQuit')">
                {{modalButtonQuit}}
              </button>
              <!-- Bouton Quitter !-->
              <button class="modal-button-confirm" @click="$emit('btnStay')">
                {{modalButtonStay}}
              </button>
              </div>
          </div>
        </div>
      </div>
    </div>
</div>
</div>
</template>

<script>
export default {
    props : {
        showModal : {
        type : Boolean,
        default : false
        },
        modalTitleMessage : {
        type : String,
        default : "Aucun message a afficher"
        },
        modalButtonStay : {
        type : String,
        default : "Texte pour bouton ici..."
        },
        modalButtonQuit : {
        type : String,
        default : "Texte pour bouton ici..."
        },
        modalParagraphMessage : {
        type : String,
        default : "Paragraphe ici..."
        },
    },
}
</script>
<style lang="scss" scoped>
.modal-mask {
position: fixed;
z-index: 9998;
top: 0;
left: 0;
width: 100%;
height: 100%;
background-color: rgba(255, 255, 255, 0.5);
display: table;
transition: opacity 0.3s ease;
}
.modal-wrapper {
display: table-cell;
vertical-align: middle;
}
.modal-container {
width: 400px;
margin: 0px auto;
padding: 20px 30px;
background-color: #c9bad2;
border-radius: 15px;
transition: all 0.3s ease;
.modal-header h3 {
  text-align: center;
  font-size: 1.8rem;
  font-weight: bold;
  color: #663682;
}
.modal-body p {
  text-align: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #663682;
}
.footer-modal-button-group{
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding: 5px;
.modal-button-confirm {
color: #663682;
    font-weight: bold;
    border: solid 1px #663682;
    border-radius: 15px;
    margin-top: 10px;
}
.modal-button-close {
background-color: #663682;
    font-weight: bold;
    border-radius: 15px;
    color: #c9bad2;
}
}
}

</style>